import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api, usdFromMicros } from '../api.js';

export function CampaignBudget({ campaign, onSaved }) {
  const [value, setValue] = useState(
    (Number(campaign.max_cost_microusd) / 1_000_000)
      .toFixed(6)
      .replace(/0+$/, '')
      .replace(/\.$/, ''),
  );
  const mutation = useMutation({
    mutationFn: (input) => api.updateCampaignBudget(campaign.id, input),
    onSuccess: onSaved,
  });
  const valid = /^\d{1,9}([.,]\d{1,6})?$/.test(value);
  function save(event) {
    event.preventDefault();
    if (!valid) return;
    const [whole, fraction = ''] = value.replace(',', '.').split('.');
    const micros = BigInt(whole) * 1_000_000n + BigInt(fraction.padEnd(6, '0'));
    mutation.mutate({
      requestId: crypto.randomUUID(),
      expectedMaxCostMicroUsd: String(campaign.max_cost_microusd),
      maxCostMicroUsd: String(micros),
    });
  }
  return (
    <form onSubmit={save} className="space-y-2 border-t border-slate-200 pt-4">
      <label className="block text-sm font-medium" htmlFor="campaign-budget">
        Limite total da campanha (US$)
      </label>
      <div className="flex gap-3 items-center">
        <input
          id="campaign-budget"
          className="border border-slate-300 rounded-lg px-3 py-2 w-36"
          inputMode="decimal"
          value={value}
          onChange={(event) => setValue(event.target.value)}
        />
        <button type="submit" className="btn-secondary" disabled={!valid || mutation.isPending}>
          {mutation.isPending ? 'Salvando…' : 'Salvar limite'}
        </button>
      </div>
      <p className="text-xs text-slate-600">
        Atual: {usdFromMicros(campaign.max_cost_microusd)}. Salvar não inicia a campanha. O limite
        do tenant também precisa permitir o consumo.
      </p>
      {mutation.error && (
        <p role="alert" className="text-red-600 text-sm">
          {mutation.error.message}
        </p>
      )}
      {mutation.isSuccess && (
        <p role="status" className="text-emerald-700 text-sm">
          Limite salvo.
        </p>
      )}
    </form>
  );
}
